/**
 * Shared constants for scene trim/extend functionality.
 * Used across multiple components to ensure consistency.
 */

/** Minimum allowed scene duration in frames (prevents trimming too short) */
export const MIN_SCENE_DURATION_FRAMES = 10;

/** Maximum extension multiplier - allows extending scene to 2x original duration */
export const MAX_EXTENSION_MULTIPLIER = 2;
